module.exports = __webpack_public_path__ + "static/media/qr-code-footer.85d34d1d.png";